import { render, staticRenderFns } from "./RequestTagsCell.vue?vue&type=template&id=3fff77a8&scoped=true"
import script from "./RequestTagsCell.vue?vue&type=script&lang=js"
export * from "./RequestTagsCell.vue?vue&type=script&lang=js"
import style0 from "./RequestTagsCell.vue?vue&type=style&index=0&id=3fff77a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff77a8",
  null
  
)

export default component.exports